import React from "react";
import { AnimatePresence, motion } from 'framer-motion'
import { Icon } from "@iconify/react";

interface NotificationProps {
  message: string;
  showToast?: boolean
}

const Notification: React.FC<NotificationProps> = ({ message, showToast =true }) => {
  return (
    <AnimatePresence>
        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="fixed bottom-6 right-6 z-[9000] bg-tealGreen text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2"
          >
            <Icon icon="mdi:check-circle-outline" className="w-5 h-5" />
            <span>{message}</span>
          </motion.div>
        )}
      </AnimatePresence>
  );
};

export default Notification;
